// @ts-nocheck
/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * SUREnet crm-internal API
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { CollectionResultOfCrmGebruikersGetGebruikersLikeStringDto } from '../model/collectionResultOfCrmGebruikersGetGebruikersLikeStringDto';

import type { CollectionResultOfCrmMedewerkersMedewerkerDto } from '../model/collectionResultOfCrmMedewerkersMedewerkerDto';

import type { GebruikerFotoUploadenBody } from '../model/gebruikerFotoUploadenBody';

import type { GebruikerSearchParams } from '../model/gebruikerSearchParams';

import type { Result1OfCrmGebruikersGebruikerDto } from '../model/result1OfCrmGebruikersGebruikerDto';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
 * @summary Zoek naar gebruikers
 */
export const gebruikerSearch = (
  params?: MaybeRef<GebruikerSearchParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<CollectionResultOfCrmGebruikersGetGebruikersLikeStringDto>(
    { url: `/api/v1/gebruikers/search`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGebruikerSearchQueryKey = (params?: MaybeRef<GebruikerSearchParams>) =>
  ['api', 'v1', 'gebruikers', 'search', ...(params ? [params] : [])] as const;

export const getGebruikerSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof gebruikerSearch>>,
  TError = ErrorType<null | null>,
>(
  params?: MaybeRef<GebruikerSearchParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof gebruikerSearch>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGebruikerSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof gebruikerSearch>>> = ({ signal }) =>
    gebruikerSearch(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof gebruikerSearch>>,
    TError,
    TData
  >;
};

export type GebruikerSearchQueryResult = NonNullable<Awaited<ReturnType<typeof gebruikerSearch>>>;
export type GebruikerSearchQueryError = ErrorType<null | null>;

/**
 * @summary Zoek naar gebruikers
 */

export function useGebruikerSearch<
  TData = Awaited<ReturnType<typeof gebruikerSearch>>,
  TError = ErrorType<null | null>,
>(
  params?: MaybeRef<GebruikerSearchParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof gebruikerSearch>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGebruikerSearchQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
 * @summary Gebruiker ophalen
 */
export const gebruikerGet = (
  gebruikerId: MaybeRef<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  gebruikerId = unref(gebruikerId);

  return customInstance<Result1OfCrmGebruikersGebruikerDto>(
    { url: `/api/v1/gebruikers/${gebruikerId}`, method: 'GET', signal },
    options,
  );
};

export const getGebruikerGetQueryKey = (gebruikerId?: MaybeRef<number | undefined | null>) =>
  ['api', 'v1', 'gebruikers', gebruikerId] as const;

export const getGebruikerGetQueryOptions = <
  TData = Awaited<ReturnType<typeof gebruikerGet>>,
  TError = ErrorType<null | null | null>,
>(
  gebruikerId: MaybeRef<number | undefined | null>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof gebruikerGet>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGebruikerGetQueryKey(gebruikerId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof gebruikerGet>>> = ({ signal }) =>
    gebruikerGet(gebruikerId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(gebruikerId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof gebruikerGet>>, TError, TData>;
};

export type GebruikerGetQueryResult = NonNullable<Awaited<ReturnType<typeof gebruikerGet>>>;
export type GebruikerGetQueryError = ErrorType<null | null | null>;

/**
 * @summary Gebruiker ophalen
 */

export function useGebruikerGet<
  TData = Awaited<ReturnType<typeof gebruikerGet>>,
  TError = ErrorType<null | null | null>,
>(
  gebruikerId: MaybeRef<number | undefined | null>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof gebruikerGet>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGebruikerGetQueryOptions(gebruikerId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.Adviseurbeheer</li></ul>
 * @summary Upload een profielfoto voor een gebruiker.
 */
export const gebruikerFotoUploaden = (
  gebruikerId: MaybeRef<number | undefined | null>,
  gebruikerFotoUploadenBody: MaybeRef<GebruikerFotoUploadenBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  gebruikerId = unref(gebruikerId);
  gebruikerFotoUploadenBody = unref(gebruikerFotoUploadenBody);
  const formData = new FormData();
  if (gebruikerFotoUploadenBody.file !== undefined) {
    formData.append(`file`, gebruikerFotoUploadenBody.file);
  }

  return customInstance<null>(
    {
      url: `/api/v1/gebruikers/${gebruikerId}/profielfoto`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options,
  );
};

export const getGebruikerFotoUploadenMutationOptions = <
  TError = ErrorType<null | null | null>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof gebruikerFotoUploaden>>,
    TError,
    { gebruikerId: number | undefined | null; data: GebruikerFotoUploadenBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof gebruikerFotoUploaden>>,
  TError,
  { gebruikerId: number | undefined | null; data: GebruikerFotoUploadenBody },
  TContext
> => {
  const mutationKey = ['gebruikerFotoUploaden'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof gebruikerFotoUploaden>>,
    { gebruikerId: number | undefined | null; data: GebruikerFotoUploadenBody }
  > = (props) => {
    const { gebruikerId, data } = props ?? {};

    return gebruikerFotoUploaden(gebruikerId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GebruikerFotoUploadenMutationResult = NonNullable<
  Awaited<ReturnType<typeof gebruikerFotoUploaden>>
>;
export type GebruikerFotoUploadenMutationBody = GebruikerFotoUploadenBody;
export type GebruikerFotoUploadenMutationError = ErrorType<null | null | null>;

/**
 * @summary Upload een profielfoto voor een gebruiker.
 */
export const useGebruikerFotoUploaden = <
  TError = ErrorType<null | null | null>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof gebruikerFotoUploaden>>,
      TError,
      { gebruikerId: number | undefined | null; data: GebruikerFotoUploadenBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof gebruikerFotoUploaden>>,
  TError,
  { gebruikerId: number | undefined | null; data: GebruikerFotoUploadenBody },
  TContext
> => {
  const mutationOptions = getGebruikerFotoUploadenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
 * @summary Haal alle werkverdeling gebruikers op.
 */
export const gebruikerGetWerkverdelingGebruikers = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) =>
  customInstance<CollectionResultOfCrmMedewerkersMedewerkerDto>(
    { url: `/api/v1/gebruikers/werkverdeling`, method: 'GET', signal },
    options,
  );

export const getGebruikerGetWerkverdelingGebruikersQueryKey = () =>
  ['api', 'v1', 'gebruikers', 'werkverdeling'] as const;

export const getGebruikerGetWerkverdelingGebruikersQueryOptions = <
  TData = Awaited<ReturnType<typeof gebruikerGetWerkverdelingGebruikers>>,
  TError = ErrorType<null | null>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof gebruikerGetWerkverdelingGebruikers>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGebruikerGetWerkverdelingGebruikersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof gebruikerGetWerkverdelingGebruikers>>> = ({
    signal,
  }) => gebruikerGetWerkverdelingGebruikers(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof gebruikerGetWerkverdelingGebruikers>>,
    TError,
    TData
  >;
};

export type GebruikerGetWerkverdelingGebruikersQueryResult = NonNullable<
  Awaited<ReturnType<typeof gebruikerGetWerkverdelingGebruikers>>
>;
export type GebruikerGetWerkverdelingGebruikersQueryError = ErrorType<null | null>;

/**
 * @summary Haal alle werkverdeling gebruikers op.
 */

export function useGebruikerGetWerkverdelingGebruikers<
  TData = Awaited<ReturnType<typeof gebruikerGetWerkverdelingGebruikers>>,
  TError = ErrorType<null | null>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof gebruikerGetWerkverdelingGebruikers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGebruikerGetWerkverdelingGebruikersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
